import {
  axios_nomination,
} from '@/plugins/axios';

import configuration from '@/configurations';

class CustomerInquiryRepository {

  /**
   * @param {Object} criteria
   *
   * @returns {Promise}
   */
  async searchCustomersInquiry(criteria) {
    const response = await axios_nomination.get(
      `${configuration.api_host}/v1/customer-inquiry/customer-inquiries`,
      {
        params: criteria,
      }
    );

    return response.data;
  }

  /**
   *
   * @param {Object} data
   * @param {Number?} data.company_id
   * @param {Number?} data.contact_id
   * @param {Number?} data.description
   * @param {Number?} data.inquiry_type_id
   * @param {Number?} data.inquiry_sub_type_id
   * @param {String?} data.inquiry_company_homepage_url
   * @param {String?} data.inquiry_company_name
   * @param {String?} data.inquiry_direction_name
   * @param {Number?} data.job_id
   * @returns {Promise<Object>}
   */
  async createCustomersInquiry(data) {
    const response = await axios_nomination.post(
      `${configuration.api_host}/v1/customer-inquiry/customer-inquiries`,
      data
    );

    return response.data;
  }

  async getCustomerInquiriesForSpecificContact(input) {
    const {
      contact_id,
      ...params
    } = input;

    const response = await axios_nomination.get(
      `${configuration.api_host}/v1/customer-inquiry/mobile/inquiry/contact/${contact_id}`,
      {
        params,
      }
    );

    return response.data;
  }

  async getMobilePhone(job_id) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/customer-inquiry/mobile/${job_id}`
    );

    return result.data;
  }

  async acceptMobilePhoneTermsOfUse() {
    const response = await axios_nomination.post(
      `${configuration.api_host}/v1/customer-inquiry/accept-mobile-phones-terms-of-use`
    );

    return response.data;
  }
}

const customer_inquiry_repository = new CustomerInquiryRepository();

export {
  customer_inquiry_repository,
};
